export class StringUtils {
  static toCash(amount: string | number) {
    if (!amount) return '0.00';
    const value = parseFloat(amount.toString()).toFixed(2);
    if (parseFloat(value) < 0) return '0.00';
    return value;
  }

  static toUSCash(amount: string | number) {
    if (!amount) return '$0.00';
    const value = parseFloat(amount.toString()).toFixed(2);
    if (parseFloat(value) < 0) return '$0.00';
    return '$' + value;
  }

  static toFirstCap(str: string) {
    if (!str) return '';
    let lower = str.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  }

  static toFirstCapEachWord(text: string) {
    var separateWord = text.split(' ');
    for (var i = 0; i < separateWord.length; i++) {
      separateWord[i] = StringUtils.toFirstCap(separateWord[i]);
    }
    return separateWord.join(' ');
  }

  static toFormalString(str: string) {
    if (!str) return '';
    return StringUtils.toFirstCap(str.replace(/_/g, ' '));
  }

  static getInitials(str: string) {
    if (!str) return '';
    try {
      const initials = str.replace(/[^0-9a-zA-Z- ]/g, '').match(/\b\w/g);
      if (initials) {
        return initials.join('');
      }
      return '';
    } catch (err) {
      return '';
    }
  }

  static maskCC(str: string) {
    if (!str) return '****';
    try {
      let result = '';
      const endMaskIndex = str.length - 4 - 1;
      for (let i = 0; i < str.length; i++) {
        if (i <= endMaskIndex) {
          result += '*';
        } else result += str.charAt(i);
      }
      return result;
    } catch (err) {
      return '****';
    }
  }

  static addParamsToUrl(url: string, params: Record<string, any>) {
    let isFirstParam = true;
    let result = url;
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      const valueAsString = Array.isArray(value) ? value.join(',') : value.toString();
      if (isFirstParam) {
        result += '?' + key + '=' + valueAsString;
        isFirstParam = false;
      } else {
        result += '&' + key + '=' + valueAsString;
      }
    });
    return result;
  }

  static generatePassCode(length: number) {
    let result = '';
    for (let i = 0; i < length; i++) {
      result += Math.floor(Math.random() * 10);
    }
    return result;
  }

  static generateUniquePassCode(existPassCodes: string[] = []) {
    let passcode = StringUtils.generatePassCode(6);
    while (!passcode || existPassCodes.includes(passcode)) {
      passcode = StringUtils.generatePassCode(6);
    }
    return passcode;
  }

  static toStringNumber(str: string, minLength = 4) {
    let result = str;
    while (result.length < minLength) {
      result = '0' + result;
    }
    return result;
  }

  static toAlphaNumericSpaceOnly(str: string): string {
    return str.replace(/[^.^ a-z0-9]/gi, '');
  }

  static toAlphaNumericOnly(str: string): string {
    return str.replace(/[^.a-z0-9]/gi, '');
  }

  static isAlphaNumericOnly(str: string): boolean {
    return StringUtils.toAlphaNumericOnly(str) === str;
  }

  static getFileExtension(filename: string): string {
    return filename.split('.').pop() || '';
  }

  static convertToAbsoluteUrl(url: string): string {
    if (url.includes('http://') || url.includes('https://')) {
      return url;
    }
    return 'http://' + url;
  }
}
